import { useEffect, useState } from 'react';

interface VisualViewport {
  height: number;
  width: number;
}

export const useVisualViewport = () => {
  const [visualViewport, setVisualViewport] = useState<VisualViewport>({
    width: window.visualViewport?.width ?? window.innerWidth,
    height: window.visualViewport?.height ?? window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setVisualViewport({
        height: window.visualViewport?.height ?? window.innerHeight,
        width: window.visualViewport?.width ?? window.innerWidth,
      });
    };

    window.visualViewport?.addEventListener('resize', handleResize);

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, []);

  return visualViewport;
};
